import React, { useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faPlus } from '@fortawesome/free-solid-svg-icons';
import { withNamespaces } from 'react-i18next';

/**
 * MeasurementUnitsTab component serves as a navigation hub for measurement units management
 * @param {Object} props - Component props
 * @returns {JSX.Element}
 */
const MeasurementUnitsTab = (props) => {
  const { t, i18n } = props;
  const history = useHistory();
  const { lng } = useParams();
  
  useEffect(() => {
    // Clear any tab change detection when component mounts
    if (props.detectChangesIndividualTab) {
      props.detectChangesIndividualTab(false);
    }
  }, []);
  
  /**
   * Navigate to measurement units list page
   */
  const navigateToList = () => {
    history.push(`/${lng}/settings/measurement-units`);
  };
  
  /**
   * Navigate to add new measurement unit page
   */
  const navigateToAdd = () => {
    history.push(`/${lng}/settings/measurement-units/add`);
  };
  
  return (
    <div className="tab-content-wrapper">
      <div className="page-header">
        <div className="page-title">
          <h4>{t('measurementUnits.tab.title')}</h4>
          <h6>{t('measurementUnits.tab.subtitle')}</h6>
        </div>
        <div className="page-btn">
          <Button 
            variant="primary" 
            className="me-2" 
            onClick={navigateToList}
          >
            <FontAwesomeIcon icon={faList} className="me-2" />
            {t('measurementUnits.tab.buttons.viewAllUnits')}
          </Button>
          <Button 
            variant="success" 
            onClick={navigateToAdd}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            {t('measurementUnits.tab.buttons.addNewUnit')}
          </Button>
        </div>
      </div>
      
      <div className="content-section pt-4">
        <p>
          {t('measurementUnits.tab.description')}
        </p>
        
        <div className="card mt-4">
          <div className="card-body">
            <h5 className="card-title">{t('measurementUnits.tab.whatCanYouDo.title')}</h5>
            <ul className="mt-3">
              <li>{t('measurementUnits.tab.whatCanYouDo.items.create')}</li>
              <li>{t('measurementUnits.tab.whatCanYouDo.items.viewAndManage')}</li>
              <li>{t('measurementUnits.tab.whatCanYouDo.items.edit')}</li>
              <li>{t('measurementUnits.tab.whatCanYouDo.items.activateDeactivate')}</li>
              <li>{t('measurementUnits.tab.whatCanYouDo.items.delete')}</li>
            </ul>
          </div>
        </div>
        
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">{t('measurementUnits.tab.cards.viewAll.title')}</h5>
                <p className="card-text">
                  {t('measurementUnits.tab.cards.viewAll.description')}
                </p>
                <Button 
                  variant="outline-primary" 
                  onClick={navigateToList}
                  className="mt-3"
                >
                  <FontAwesomeIcon icon={faList} className="me-2" />
                  {t('measurementUnits.tab.cards.viewAll.button')}
                </Button>
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">{t('measurementUnits.tab.cards.createNew.title')}</h5>
                <p className="card-text">
                  {t('measurementUnits.tab.cards.createNew.description')}
                </p>
                <Button 
                  variant="outline-success" 
                  onClick={navigateToAdd}
                  className="mt-3"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  {t('measurementUnits.tab.cards.createNew.button')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(MeasurementUnitsTab);
